<template>
  <div class="course-bundle-show">
    <h3>{{model.qty}} <span>次</span></h3>
    <p v-text="model.type_text"></p>

    <div class="button">
      <md-button type="primary" @click="buy()">购买课包（￥：{{model.price}}）</md-button>
      <br>
      <md-button type="default" @click="goPage()">我的课包</md-button>
    </div>
  </div>
</template>

<script>
    import {Button} from 'mand-mobile'


export default {
  name: "course-bundle-show",
  components: {
      [Button.name]: Button,

  },
    data() {
      return {
          sign: false,
          model: {},
      }
    },
    created() {
        this.loadData();
    },
    methods: {
        buy() {
            if(!this.model.id)
                return;

          if(this.sign) {
            this.doPayment(this.sign);
          } else {
            this.checkout();
          }
        },
        checkout() {
            this.$toast.loading("加载中...");
            this.$http.post(`course-bundles/`+this.model.id)
                .then(({data}) => {
                    this.$toast.hide();
                    this.doPayment(data);
                })
                .catch(({response}) => {
                    this.$toast.hide();
                });
        },
        doPayment(sign) {
            this.$tools.wechatPay(sign)
                .then(() => {
                    this.$toast.succeed('支付成功');
                })
                .catch((res) => {
                    console.log(res);
                    this.$dialog.confirm({
                        title: '支付失败',
                        content: '支付失败，请重试',
                        confirmText: '重新支付',
                        onConfirm: () => this.doPayment(sign),
                        onCancel: () => {
                            this.sign = false;
                        },
                    });
                });
        },
        loadData() {
            const {id} = this.$route.params;
            this.$toast.loading("加载中...");
            this.$http.get(`course-bundles/${id}`)
                .then(({data}) => {
                    this.$toast.hide();
                    this.model = data;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        goPage() {
            this.$router.push('/my-course-bundle');
        }
    }
};
</script>


<style lang="scss" scoped>
.course-bundle-show {
  text-align: center;
  padding: 300px 20px 20px;
  h3 {
    font-weight:normal;
    font-size: 90px;
    margin-bottom: 10px;
    span {
      font-size: 28px;
      vertical-align: baseline;
    }
  }

  p {
    color: #383838;
    font-size: 28px;
    margin-top: 20px;
  }

  .button {
    position: fixed;
    left: 20px;
    right: 20px;
    bottom: 20px;

    /*margin-top: 500px;*/
  }
}

</style>
